import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';

export const useMainMenuDrawerStyles = createStyles(({ token }) => ({
  mainMenuTrigger: {
    cursor: 'pointer',
    padding: `0 ${ThemeSpaces.SPACE_NORM_30}px 0 ${ThemeSpaces.SPACE_NORM_15}px`,
  },
  drawer: {
    '&.ant-drawer-content': {
      backgroundColor: `${ThemeColors.COLOR_WHITE6} !important`,
      borderRadius: '8px 0 0 8px',
      boxShadow:
        '0 0 0 1px rgba(255, 255, 255, 1), -1px 4px 20px 0 rgba(150, 164, 189, 1)',
    },

    '.ant-drawer-header': {
      padding: `${ThemeSpaces.SPACE_XS}px ${ThemeSpaces.SPACE_MD}px`,
      borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
    },

    '.ant-drawer-body': {
      padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
    },
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: ThemeSpaces.SPACE_MD,
    color: ThemeColors.COLOR_GREY3,
    fontSize: ThemeFont.FONT_SIZE_LG_PLUS,

    '> span:last-child': {
      fontWeight: 300,
      fontSize: 24,
      color: ThemeColors.COLOR_GREY6,
    },
  },
  close: {
    color: ThemeColors.COLOR_RED,
  },
  row: {
    marginBottom: ThemeSpaces.SPACE_NORM_15,
    borderTop: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
    padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_XS}px 0 ${ThemeSpaces.SPACE_XS}px`,

    '&:first-child': {
      borderTop: 'none',
    },

    '&:last-child': {
      marginBottom: 0,
    },
  },
  rowTitle: {
    marginBottom: ThemeSpaces.SPACE_NORM_20,
  },
  columns: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: ThemeSpaces.SPACE_NORM_30,
  },
  column: {
    minWidth: 0,
  },
  section: {
    marginBottom: ThemeSpaces.SPACE_NORM_30,

    '&:last-child': {
      marginBottom: 0,
    },
  },
  sectionTitle: {
    fontSize: token.fontSizeSM,
    fontWeight: 700,
    textTransform: 'uppercase',
    color: ThemeColors.COLOR_GREY2,
    marginBottom: ThemeSpaces.SPACE_XXS,
  },
  sectionTitleSmall: {
    fontSize: token.fontSize,
  },
  group: {
    marginBottom: ThemeSpaces.SPACE_NORM_20,
  },
  groupTitle: {
    fontSize: token.fontSize,
    fontWeight: 600,
    color: ThemeColors.COLOR_GREY2,
    margin: `${ThemeSpaces.SPACE_NORM}px 0 ${ThemeSpaces.SPACE_NORM0_5}px`,
  },
  item: {
    display: 'block',
    padding: '2px 0 2px 12px',
    color: `${ThemeColors.COLOR_GREY_BLUISH6} !important`,
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '16px',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  itemAfterGroup: {
    paddingLeft: 0,
  },
  itemDisabled: {
    color: ThemeColors.COLOR_GREY4,
    cursor: 'default',
    opacity: 0.55,
    width: 'fit-content',

    '&:hover': {
      textDecoration: 'none',
    },
  },
}));
